module.exports = __webpack_public_path__ + "img/dia_inviteBg.46c4c05e.jpg";